import { OFDMChannel } from './ofdm-channel';
import { SpectrumBin } from './spectrum-bin';


export class OfdmData {
  username: string; // Here for model uniformity. necessary for referenceSweep.
  timestamp: number;
  ofdmPortId: number;
  center: number;
  width: number;
  spacing: number;
  plc: Plc;
  profiles: Profile[];
  channels: OFDMChannel[];
  mer: Mer;
  pilots: Pilot[];
  locationComment: any;
  spectrumBins: SpectrumBin[];
  ofdmScans?: OfdmData[];
  latitude?: number;
  longitude?: number;

  constructor(
    httpResponse?: OfdmData
  ) {
    if (!httpResponse) { return; }
    this.username = httpResponse.username;
    this.timestamp = httpResponse.timestamp;
    this.ofdmPortId = httpResponse.ofdmPortId;
    this.center = httpResponse.center;
    this.width = httpResponse.width;
    this.spacing = httpResponse.spacing;
    this.plc = httpResponse.plc;
    this.profiles = httpResponse.profiles;
    this.channels = httpResponse.channels;
    this.mer = httpResponse.mer;
    this.pilots = httpResponse.pilots;
    this.locationComment = httpResponse.locationComment;
    this.spectrumBins = httpResponse.spectrumBins;
    this.ofdmScans = httpResponse.ofdmScans;
    this.latitude = httpResponse.latitude;
    this.longitude = httpResponse.longitude;
  }
}

class Plc {
  frequency: number;
  power: number;
  cer: number;
  mer: number[];
}

class Mer {
  start: number;
  mer: number[];
}



class Pilot {
  frequency: number;
  mer: number;
}

class Profile {
  name: string;
  cwCount: number;
  errCount: number;
  errRatio: string;
}

